/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Represents a webhook feature configuration for a tenant
 * @export
 * @interface TenantWebhookFeature
 */
export interface TenantWebhookFeature {
    /**
     * The webhook type identifier
     * @type {string}
     * @memberof TenantWebhookFeature
     */
    webhookType: string;
    /**
     * Whether this webhook type is enabled for the tenant
     * @type {boolean}
     * @memberof TenantWebhookFeature
     */
    enabled?: boolean;
}

/**
 * Check if a given object implements the TenantWebhookFeature interface.
 */
export function instanceOfTenantWebhookFeature(value: object): value is TenantWebhookFeature {
    if (!('webhookType' in value) || value['webhookType'] === undefined) return false;
    return true;
}

export function TenantWebhookFeatureFromJSON(json: any): TenantWebhookFeature {
    return TenantWebhookFeatureFromJSONTyped(json, false);
}

export function TenantWebhookFeatureFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantWebhookFeature {
    if (json == null) {
        return json;
    }
    return {
        
        'webhookType': json['webhook_type'],
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
    };
}

export function TenantWebhookFeatureToJSON(json: any): TenantWebhookFeature {
    return TenantWebhookFeatureToJSONTyped(json, false);
}

export function TenantWebhookFeatureToJSONTyped(value?: TenantWebhookFeature | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'webhook_type': value['webhookType'],
        'enabled': value['enabled'],
    };
}

